// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3chiK","buttons":"Footer_buttons__3rHq_"};